/* [Pref*re 2026-10-05 oct5-cart] Cart drawer upsell + cart-open state.
   - [data-oct5-upsell="swap"]: adds the 3V1 first, then sets the old SOLO line to 0 (the shopper never loses the item if the add fails).
   - [data-oct5-upsell="add"]: adds ULTRA.
   Re-renders the drawer through the theme's own CartDrawer.renderContents (sections API), so totals, badge and upsell stay in sync.
   Also mirrors the drawer's open state onto <html class="oct5-cart-open"> (used to hide the Smile.io launcher in browsers without :has()). */
(function () {
  if (window.__oct5CartUpsell) return;
  window.__oct5CartUpsell = true;

  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  var routes = window.routes || {};
  var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
  var changeUrl = (routes.cart_change_url || '/cart/change') + '.js';

  function drawer() { return document.querySelector('cart-drawer'); }

  function liveRegion() {
    var d = drawer();
    if (!d) return null;
    var el = document.getElementById('Oct5CartLive');
    if (!el) {
      el = document.createElement('p');
      el.id = 'Oct5CartLive';
      el.className = 'visually-hidden';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      d.appendChild(el);
    }
    return el;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'cart');
        return j;
      });
    });
  }

  function render(state, doneMsg) {
    var d = drawer();
    if (d && typeof d.renderContents === 'function' && state && state.sections) {
      d.renderContents(state);
    }
    setTimeout(function () {
      var target = document.querySelector('#CartDrawer .cart-item__name') || document.querySelector('#CartDrawer .drawer__close');
      var wrap = document.getElementById('CartDrawer');
      if (target && wrap && typeof window.trapFocus === 'function') window.trapFocus(wrap, target);
      else if (target) target.focus({ preventScroll: true });
      var lr = liveRegion();
      if (lr && doneMsg) { lr.textContent = ''; setTimeout(function () { lr.textContent = doneMsg; }, 60); }
    }, 80);
  }

  function refreshOnly() {
    return fetch((routes.cart_url || '/cart') + '?sections=' + SECTIONS.join(','))
      .then(function (r) { return r.json(); })
      .then(function (sections) { render({ sections: sections }); })
      .catch(function () {});
  }

  function setBusy(box, btn, busy) {
    box.setAttribute('aria-busy', busy ? 'true' : 'false');
    box.querySelectorAll('[data-oct5-upsell]').forEach(function (b) {
      if (busy) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    });
    btn.classList.toggle('is-loading', busy);
  }

  function showError(box) {
    var err = box.querySelector('.oct5-cart-upsell__error');
    if (!err) return;
    err.textContent = 'Couldn’t update your bag. Try again.';
    err.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-oct5-upsell]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var box = btn.closest('.oct5-cart-upsell');
    var action = btn.getAttribute('data-oct5-upsell');
    var addId = parseInt(btn.getAttribute('data-add-id'), 10);
    var lineKey = btn.getAttribute('data-line-key');
    var doneMsg = btn.getAttribute('data-done');
    setBusy(box, btn, true);

    var p;
    if (action === 'swap') {
      p = post(addUrl, { items: [{ id: addId, quantity: 1 }] }).then(function () {
        return post(changeUrl, { id: lineKey, quantity: 0, sections: SECTIONS, sections_url: window.location.pathname })
          .catch(function () { return refreshOnly().then(function () { return null; }); });
      });
    } else {
      p = post(addUrl, { items: [{ id: addId, quantity: 1 }], sections: SECTIONS, sections_url: window.location.pathname });
    }

    p.then(function (state) {
      if (state) render(state, doneMsg);
    }).catch(function () {
      setBusy(box, btn, false);
      showError(box);
    });
  });

  /* Mirror the drawer's open state for CSS (Smile.io launcher hide, no :has() needed). */
  function watch() {
    var d = drawer();
    if (!d) return;
    var sync = function () { document.documentElement.classList.toggle('oct5-cart-open', d.classList.contains('active')); };
    new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['class'] });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
